import _ from 'lodash';

import type { ErrorFieldType } from '@/types';

export const identificationHasErrors = (errors: ErrorFieldType[]) =>
  _.some(errors, ({ id }) =>
    _.includes(
      [
        'titre',
        'collectivite',
        'codeInterne',
        'adresse',
        'service',
        'horairesOuverture',
        'mail',
        'telephone',
        'website',
      ],
      id,
    ),
  );

export const regisseursHasErrors = (errors: ErrorFieldType[]) =>
  _.some(errors, ({ id }) => _.includes(['regisseurConnexion', 'regisseurs'], id));

export const posteComptableHasErrors = (errors: ErrorFieldType[]) =>
  _.some(errors, ({ id }) =>
    _.includes(
      [
        'tresorerie',
        'depotFondTresor',
        'ribDepot',
        'intituleCompteDepot',
        'protocoleImpaye',
        'seuilRecouvrement',
      ],
      id,
    ),
  );

export const encaisseArretesHasErrors = (errors: ErrorFieldType[]) =>
  _.some(errors, ({ id }) =>
    _.includes(
      [
        'encaisseMaximum',
        'encaisseNumeraireMaximum',
        'fondCaisse',
        'periodiciteVersementEncaisseGlobale',
        'periodiciteArrete',
      ],
      id,
    ),
  );

export const modesReglementHasErrors = (errors: ErrorFieldType[]) =>
  _.some(errors, ({ id }) => _.includes(['modesReglements'], id));

export const regieProlongeeHasErrors = (errors: ErrorFieldType[]) =>
  _.some(errors, ({ id }) =>
    _.includes(
      [
        'regieProlongee',
        'joursEncaissementSupplementaires',
        'seuilRelance',
        'envoiRelanceParMail',
        'seuilRelanceAvantEcheance',
        'envoiRelanceAvantEcheanceParMail',
      ],
      id,
    ),
  );
